<template lang="pug">
  #default-layout
    template(v-if="loaded")
      TopNav
      RouterView(:key="$route.fullPath")
      MobileFooter(v-if="showMobileFooter")
      LegalLinks(v-if="!$breakpoint.isTouch")

    AppModal(v-if="$modal.visible")
</template>

<script>
export default {
  props: {},

  data() {
    return {
      loaded: false,
    }
  },

  computed: {
    showMobileFooter,
  },

  watch: {},

  methods: {},

  created() {
    this.$auth.load().then(() => {
      this.$app.user = this.$auth.user()

      this.$cable.connection.connect(
        `${process.env.VUE_APP_API_URL}/realtime?token=${this.$auth.user().accessToken}`
      )

      this.loaded = true
    })
  },

  components: {
    AppModal: require('@/components/AppModal').default,
    LegalLinks: require('@/components/LegalLinks').default,
    MobileFooter: require('@/components/MobileFooter').default,
    TopNav: require('@/components/TopNav').default,
  },
}

/* Computed ---------------------------------------------------- */
function showMobileFooter() {
  return this.$breakpoint.isTouch && this.$route.name != 'userSettings'
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
